import React, { useEffect, useRef, useState } from 'react';

import useClickOutside from '@hooks/useClickOutside';

const OtherMarkets = ({ selectedMarkets, marketList, toggleSelectedMarket }) => {
	const dropdownRef = useRef(null);
	const [search, setSearch] = useState('');
	const [markets, setMarkets] = useState([]);
	const [isShowOpen, setIsShowOpen] = useState(false);

	useClickOutside(dropdownRef, () => setIsShowOpen(false));

	useEffect(() => {
		if (search) {
			let filteredData = marketList?.filter((item) => item.name.toLowerCase() === search.toLowerCase());
			setMarkets(filteredData);
		} else {
			setMarkets(marketList);
		}
	}, [search, marketList]);

	const renderMarkets = () => {
		return markets?.map((item) => {
			let isSelected = selectedMarkets.find((market) => market.id === item.id);
			return (
				<div className="form-group" key={`market_${item.id}`}>
					<input
						type="checkbox"
						id={`other_market_${item.id}`}
						name={`other_market_${item.id}`}
						checked={!!isSelected}
						onChange={() => toggleSelectedMarket(item)}
					/>
					<label className="regular-14 gray_dark_02" htmlFor={`other_market_${item.id}`}>
						<span>{item.name}</span>
					</label>
				</div>
			);
		});
	};

	return (
		<div className="category-dropdown from-group" ref={dropdownRef}>
			<div className="select-component">
				<div className="click-box click mb-1" onClick={() => setIsShowOpen((prev) => !prev)}>
					<p className="regular-14 ">Other Markets</p>
					<img src={`${process.env.PUBLIC_URL}/images/chevron_down.svg`} alt="" />
				</div>
				<div className={`dropdown-box ${isShowOpen ? '' : 'd-none'}`}>
					<div className="m-0 search-filter">
						<div className="with-icon right-icon">
							<input
								type="text"
								placeholder="Search"
								value={search}
								onChange={(e) => setSearch(e.target.value)}
							/>
							<span className="right-icon">
								<img src={`${process.env.PUBLIC_URL}/icons/search.png`} alt="" />
							</span>
						</div>
					</div>
					<div className="list-items scroll-y-label pl-3">
						<div className="single-item custom-chekbox">{renderMarkets()}</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default OtherMarkets;
